module.exports = __webpack_public_path__ + "img/banner02.a55ca072.jpeg";